import React from 'react';
import { useDispatch } from 'react-redux';
import { parse, differenceInDays } from 'date-fns';
import format from '../../../../utilities/format';
import { applyHistorySearch } from '../../mainFilterSlice';
import translate from '../../../../utilities/translator';
import { pushEvent } from '../../../../utilities/analytics';
import { WHERE_FILTER_RECENT_SEARCH } from '../../../../constants/analyticEvents';
import { setLastChangedFilter } from '../../../../appSlice';
import { updateSearch } from '../../searchSlice';

export default function RecentSearchItem({ item, onApply }) {
  const dispatch = useDispatch();
  const { who, where, when } = item.data;
  const startDate = parse(when.startDate, 'dd/MM/yyyy', new Date());
  const endDate = parse(when.endDate, 'dd/MM/yyyy', new Date());
  const location = where.destinations?.find((item) => item.active);
  const daysLabel = differenceInDays(endDate, startDate);
  const monthsLabel =
    format(startDate, 'MMM') === format(endDate, 'MMM')
      ? format(startDate, 'MMM')
      : `${format(startDate, 'MMM')} - ${format(endDate, 'MMM')}`;
  const guestsLabel = `${who.adults} ${translate(
    'holidayFinder.general.adults_plural', { count: who.adults }
  )} ${
    who.children > 0
      ? ` & ${who.children} ${translate('holidayFinder.general.children_plural', {
          count: who.children,
        })}`
      : ''
  } ${
    who.rooms > 1
      ? ` & ${who.rooms} ${translate('holidayFinder.general.rooms_plural', {
          count: who.rooms,
        })}`
      : ''
  }`;

  const searchLabel = translate('holidayFinder.recentSearch.searchParams', {
    nights: daysLabel,
    months: monthsLabel,
    guests: guestsLabel,
  });

  const handleItemClick = () => {
    dispatch(setLastChangedFilter('where'));
    dispatch(
      updateSearch({
        when
      })
    );
    dispatch(applyHistorySearch(item));
    pushEvent(WHERE_FILTER_RECENT_SEARCH, { searchData: item });
    onApply();
  };

  return (
    <div className="history__item" onClick={handleItemClick}>
      <div className="history__item-title">{location.name}</div>
      <div className="history__item-settings">{searchLabel}</div>
    </div>
  );
}
